import React, { useState } from "react";

export default function QuickPlayModal({
  open,
  onClose,
  onFindOpponent,
  balance,
}) {
  const [bet, setBet] = useState(0.5);
  const min = 0.5;
  const max = Math.floor((balance ?? 0) * 100) / 100; // 2 decimals

  const handleFind = () => {
    if (bet < min || bet > max) return;
    onFindOpponent(Number(bet));
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="bg-[#101622] rounded-2xl shadow-2xl p-8 max-w-xs w-full flex flex-col items-center border-2 border-lime-400/80">
        <button
          className="absolute right-8 top-8 text-2xl text-lime-400 hover:text-lime-300"
          onClick={onClose}
        >
          ✕
        </button>
        <h2 className="font-extrabold text-2xl text-lime-400 mb-6 text-center drop-shadow">
          Enter Bet Amount
        </h2>
        <input
          type="number"
          min={min}
          max={max}
          step="0.1"
          className="w-full text-center text-3xl font-black rounded-xl bg-[#182233] text-lime-300 border-2 border-lime-400 outline-none py-2 mb-3 transition-all focus:ring-2 focus:ring-lime-400"
          value={bet}
          onChange={(e) => setBet(Number(e.target.value))}
          disabled={balance < min}
        />
        <div className="mb-4 text-sm text-slate-400 w-full text-center">
          {balance < min ? (
            <span className="text-pink-400 font-bold">
              Insufficient balance
            </span>
          ) : (
            <>
              Your Balance:{" "}
              <span className="text-lime-400 font-semibold">
                {balance?.toFixed(2)} USDT
              </span>
            </>
          )}
        </div>
        <button
          onClick={handleFind}
          disabled={bet < min || bet > max || balance < min}
          className={`w-full py-3 rounded-xl font-extrabold text-lg mt-1 mb-2 shadow
            ${
              bet < min || bet > max || balance < min
                ? "bg-gray-500 text-gray-200 cursor-not-allowed"
                : "bg-gradient-to-r from-lime-400 via-lime-500 to-green-500 text-white hover:scale-105 hover:shadow-2xl transition-all duration-150"
            }`}
        >
          Find Opponent
        </button>
        <button
          onClick={onClose}
          className="w-full py-2 rounded-xl bg-slate-700 text-slate-200 font-bold hover:bg-slate-600"
        >
          Cancel
        </button>
        <div className="text-xs text-slate-400 mt-2 italic">
          Min: <span className="text-lime-400 font-semibold">0.5 USDT</span>
        </div>
      </div>
    </div>
  );
}
